import * as React from 'react'

import {
  Box,
  Icon,
  type MediumIcon,
  Text,
  useClassNames,
} from '@factorialco/deprecated-design-system'

import useFilter from 'modules/core/components/Filter/base/useFilter'

import { CHIP_MAX_WIDTH } from './constants'
import * as styles from './index.vanilla.css'

const ICON_WIDTH = 40
const PADDING_X = 20
const GAP = 4
const TEXT_MAX_WIDTH = CHIP_MAX_WIDTH - ICON_WIDTH - PADDING_X - GAP

type Props = {
  label?: string
  activeLabel?: string
  icon: MediumIcon
}

export default function ChipWithIcon<Value>({ label, activeLabel, icon }: Props) {
  const { open, setOpen } = useFilter<Value>()
  const cx = useClassNames(styles)

  const onClick = () => setOpen(!open)

  return (
    <button className={cx('chip')} onClick={onClick} aria-label="show list">
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        gap="s4"
        style={{ maxWidth: `${TEXT_MAX_WIDTH}px` }}
      >
        <Icon.Medium icon={icon} color="grey600" />
        <Text.Normal lineClamp={0} size="200" color="grey800" ellipsis>
          {label ?? activeLabel}
        </Text.Normal>
        <span className={cx('arrow')}>
          <Icon.Small icon="chevron-down" color="grey600" />
        </span>
      </Box>
    </button>
  )
}
